import { DateTime, Duration } from 'luxon';
import { ImportConfigurationAS2DTO, ImportConfigurationEmailDTO, ImportConfigurationFileDTO, ImportConfigurationFTPClientDTO, ImportConfigurationRESTDTO, ImportConfigurationSFTPDTO, ImportConfigurationTimeScheduleDTO, ImportConfigurationTransferType, ClientDTO, ImportType, ExportInterfaceConfigurationRESTAuthType, ImportFileFormat, ExportInterfaceConfigurationDecimalSeparator, ExportInterfaceConfigurationTextFormat, FTPClientType, WeekdayFlag, ImportConfigurationAcodisDTO, ImportConfigurationType, ImportConfigurationClientAccessType, ImportConfigurationParashiftDTO } from '../../../base/models/models.swagger.generated';
import { ImportConfigurationDTO } from "src/app/base/models/models.swagger.generated";

export class CreateConfigurationUtil {

  public static createNewImportConfigurationDTO(client: ClientDTO): ImportConfigurationDTO {
      var dto = new ImportConfigurationDTO({
      id: 0,
      client: client,
      configurationName: null,
      transferType: ImportConfigurationTransferType.Email,
      importType: ImportType.SalesOrder,
      isActive: false,
      type: ImportConfigurationType.Configuration,
      clientAccessType: ImportConfigurationClientAccessType.Client,
      userAssignments: [],
      timeScheduleConfig: this.createNewTimeScheduleDto(),
      emailConfig: this.createNewEmailDto(),
      sFTPConfig: this.createNewSftpDto(),
      fTPClientConfig: this.createNewFtpClientDto(),
      rESTConfig: this.createNewRestDto(),
      as2Config: this.createNewAs2Dto(),
      fileConfig: this.createNewFileDto(),
      acodisConfig: this.createNewAcodisDto(),
      parashiftConfig: this.createNewParashoftDto()
    });

    return dto;
  }

  public static createNewParashoftDto(): ImportConfigurationParashiftDTO {
    return new ImportConfigurationParashiftDTO();
  }

  public static createNewTimeScheduleDto(): ImportConfigurationTimeScheduleDTO {
    var dto = new ImportConfigurationTimeScheduleDTO({
      startDate: DateTime.now(),
      hasEndDate: false,
      endDate: null,
      startTime: Duration.fromObject({ hours: DateTime.now().hour, minutes: DateTime.now().minute }),
      endTime: Duration.fromObject({ hours: 23, minutes: 59 }),
      repetitionIntervalInMinutes: 1440,
      onWeekDays: 31 as WeekdayFlag
    });

    return dto;
  }

  public static createNewEmailDto(): ImportConfigurationEmailDTO {
    var dto = new ImportConfigurationEmailDTO({
      emailAccountId: 0,
      mandatorySubjectContent: null,
      mandatoryBodyContent: null,
      senderEmailAddress: null
    });

    return dto;
  }

  public static createNewSftpDto(): ImportConfigurationSFTPDTO {
    var dto = new ImportConfigurationSFTPDTO({});
    return dto;
  }

  public static createNewFtpClientDto(): ImportConfigurationFTPClientDTO {
    var dto = new ImportConfigurationFTPClientDTO({
      url: null,
      port: 21,
      fTPClientType: FTPClientType.Ftp,
      userName: null,
      password: null,
      relativePath: null,
      deleteFilesAfterTransmission: false,
      useCertificate: false,
      certificateMediaId: null,
      certificateMediaName: null,
      certificatePassword: null,
      certificateMediaType: null,
      certificateContentBase64: null,
    });

    return dto;
  }

  public static createNewRestDto(): ImportConfigurationRESTDTO {
    var dto = new ImportConfigurationRESTDTO({
      accessType: ExportInterfaceConfigurationRESTAuthType.BearerToken,
      clientId: null,
      clientSecret: null,
      aPIFixKey: null,
      aPIFixValue: null,
      refreshTokenLifetimeInHours: 1
    });

    return dto;
  }

  public static createNewAs2Dto(): ImportConfigurationAS2DTO {
    var dto = new ImportConfigurationAS2DTO({
      aS2From: null,
      aS2To: null,
      useCompression: true,
      doSignMessages: false,
      certificateMediaId: null,
      certificateMediaName: null,
      certificatePassword: null,
      certificateMediaType: null,
      certificateContentBase64: null,
    });

    return dto;
  }

  public static createNewFileDto(): ImportConfigurationFileDTO {
    var dto = new ImportConfigurationFileDTO({
      fileFormat: ImportFileFormat.CSV,
      isTitleContainedInFile: true,
      decimalSeparator: ExportInterfaceConfigurationDecimalSeparator.Comma,
      separatorCharacter: null,
      textFormat: ExportInterfaceConfigurationTextFormat.UTF8,
      fileNameSearchPattern: null,
      fieldAssignments: [],
      possibleSources: [],
      sendResponse: false
    });

    return dto;
  }

  public static createNewAcodisDto(): ImportConfigurationAcodisDTO {
    var dto = new ImportConfigurationAcodisDTO({
      acodisWorkflowId: null,
      category: null,
    });

    return dto;
  }
}
